import { render, staticRenderFns } from "./BiometricAuthSetup.vue?vue&type=template&id=3d21ec72&scoped=true"
import script from "./BiometricAuthSetup.vue?vue&type=script&lang=ts"
export * from "./BiometricAuthSetup.vue?vue&type=script&lang=ts"
import style0 from "./BiometricAuthSetup.vue?vue&type=style&index=0&id=3d21ec72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d21ec72",
  null
  
)

export default component.exports